import styled from "styled-components";
import { BasePriceStyles, PriceBackgroundStyles } from "./PriceShared.styles";

export const MainPrice = styled.div`
  ${BasePriceStyles}
  ${PriceBackgroundStyles}
`;
